import ValueState from '@ui5/webcomponents-base/dist/types/ValueState';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { validateFieldLength, validateString } from 'utils/validator';

export const useQTProjectImportDialog = () => {
  const [searchTermValueState, setSearchTermValueState] = useState(ValueState.None);
  const [startDateValueState, setStartDateValueState] = useState(ValueState.None);
  const [endDateValueState, setEndDateValueState] = useState(ValueState.None);
  const [isValid, setIsValid] = useState(false);
  const [searchTermValue, setSearchTermValue] = useState('');
  const [startDateValue, setStartDateValue] = useState('');
  const [endDateValue, setEndDateValue] = useState('');

  const validate = () => {
    const projectValid =
      validateString(searchTermValue, setSearchTermValueState) &&
      validateFieldLength(searchTermValue, 3, setSearchTermValueState);
    const startDateValid = validateString(
      startDateValue,
      setStartDateValueState,
      ValueState.Negative,
      ValueState.None
    );
    const endDateValid = validateString(
      endDateValue,
      setEndDateValueState,
      ValueState.Negative,
      ValueState.None
    );

    setIsValid(projectValid && startDateValid && endDateValid);
  };

  useEffect(() => {
    setIsValid(false);
  }, [searchTermValueState, startDateValueState, endDateValueState]);

  const formatDate = (date: string) => {
    return dayjs(date).format('YYYY-MM-DD');
  };

  return {
    isValid,
    validate,
    searchTermValueState,
    startDateValueState,
    endDateValueState,
    searchTermValue,
    startDateValue,
    endDateValue,
    setSearchTermValue,
    setStartDateValue,
    setEndDateValue,
    formatDate
  };
};
